<div class="ai-credits-container">
        <div class="header">
            <i class="db-icon db-icon-ds-ai"></i>
            <div class="title mt6">
                {{ 'text_aiCreditsUsed' | dbText}}
            </div>
        </div>
        <div class="ai-credits-progress mt1"
             [ngClass]="{ 'unlimited': (+this.creditsLimit()) > 10000 }">
            <db-progress-bar
                    size="sm"
                    [state]="aiCreditsMode()"
                    [progressPercent]="creditsUsedPercentage()">
            </db-progress-bar>
            <div class="ai-credits-number">
                <ng-container *ngIf="(+this.creditsLimit()) > 10000; else showCredits">
                    Unlimited
                </ng-container>
                <ng-template #showCredits>
                    {{ this.creditsUsed() }}/{{ +this.creditsLimit() }}
                </ng-template>
            </div>
        </div>
        <div class="ai-credits-notif">
            {{ 'text_anyAiRequestCostsCredit' | dbText}}
        </div>
        @if (aiCreditsMessage().showMessage) {
            <div class="credits-message {{aiCreditsMessage().className}}">
                <div class="title">{{ aiCreditsMessage().title }}</div>
                <div class="subtitle">{{ aiCreditsMessage().subtitle }}</div>
            </div>
        }
    </div>
